import React, { useEffect, useRef, useState } from 'react';
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TimelineComponent = (/* props: IPlatformProjectProps */) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const imagesRef = useRef<HTMLImageElement[]>([]);
	const textRef = useRef<HTMLDivElement[]>([]);
	const [width, setWidth] = useState(window.innerWidth);
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => {
			window.removeEventListener("resize", updateDimensions);
		}
	}, []);
	
	const addToRefs = <T,>(refArray: React.MutableRefObject<T[]>, el: T | null) => {
		if (el && !refArray.current.includes(el)) {
			refArray.current.push(el);
		}
	};
	
	return (
		<div className="timelineComponent projectsPanel" ref={containerRef} id="testComp__content_data_item_id_1">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="timelineComponent__content">
				<div className="timelineComponent__content_images">
					<div className="timelineComponent__content_images_main">
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/timeline/MainImage.webp`}
							alt="Main"
							ref={(el) => addToRefs(imagesRef, el)}
						/>
					</div>
					<div className="timelineComponent__content_images_second" >
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/timeline/SecondImage.webp`}
							alt="Second"
							ref={(el) => addToRefs(imagesRef, el)}
						/>
						<div
							className="timelineComponent__content_images_second_background_1"
							ref={(el) => addToRefs(imagesRef, el as HTMLImageElement)}
						></div>
						<div
							className="timelineComponent__content_images_second_background_2"
							ref={(el) => addToRefs(imagesRef, el as HTMLImageElement)}
						></div>
					</div>
				</div>
				
				<div className="timelineComponent__content_data">
					{
						width > 1023 ? (
							<div
								className="timelineComponent__content_data_item"
								ref={(el) => addToRefs(textRef, el)}
							>
								<h3>Timeline</h3>
								<span>
              Inside each card you can find the Timeline, so you will see the
              specific deadlines of each activity, if any.
            </span>
							</div>
						) : null
					}
					<div
						className="timelineComponent__content_data_item"
						ref={(el) => addToRefs(textRef, el)}
					>
						<h3>Add a timeline to your calendar</h3>
						{
							width > 1023 ? (
								<span>
              and you will never forget the important deadlines for every
              project you participate in.
            </span>
							) : (
								<span>
										Inside each card you can find the Timeline, so you will see the specific deadlines of each activity.<br/><br/>Due to calendar feature you will never forget the important deadlines for every project you participate in.
                </span>
							)
						}
					</div>
					<div
						className="timelineComponent__content_data_arrow"
						ref={(el) => addToRefs(textRef, el)}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/timeline/DottedArrow.webp`}
							alt="Dotted arrow"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TimelineComponent;